// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import {
  ObjectDataDeployment,
  TCCService,
  TemplateFragmentDeployment,
  TenantDestruction,
  UserProvisioningDeployment,
} from '@/services/tcc/configurator'

export type {
  ObjectDataDeployment,
  TemplateFragmentDeployment,
  TenantDestruction,
  UserProvisioningDeployment,
}

export const getTemplateFragmentDeployments = async (
  tenantId: string
): Promise<TemplateFragmentDeployment[]> => {
  const resp = await TCCService.GetTemplateFragmentDeployments({ tenantId })
  return resp.templateFragmentDeployments ?? []
}

export const getTenantDestructions = async (
  tenantId: string
): Promise<TenantDestruction[]> => {
  const resp = await TCCService.GetTenantDestructions({ tenantId })
  return resp.tenantDestructions ?? []
}

export const getObjectDataDeployments = async (
  tenantId: string
): Promise<ObjectDataDeployment[]> => {
  const resp = await TCCService.GetObjectDataDeployments({ tenantId })
  return resp.objectDataDeployments ?? []
}

export const getUserProvisioningDeployments = async (
  tenantId: string
): Promise<UserProvisioningDeployment[]> => {
  const resp = await TCCService.GetUserProvisioningDeployments({ tenantId })
  return resp.userProvisioningDeployments ?? []
}

export const initiateTenantExport = async (request: {
  tenantId: string
  templateName: string
  templateDescription: string
  includeObjectData: boolean
  excludedObjectDefinitions: string[]
}) => {
  return TCCService.InitiateTenantExport(request)
}

export const listObjectDefinitions = async (
  tenantId: string
): Promise<string[]> => {
  const resp = await TCCService.ListObjectDefinitions({ tenantId })
  return resp.objectDefinitions.map((od) => od.name)
}
